import { useSetRecoilState } from 'recoil';

import Button from 'components/common/Button/Button';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';

/**
 * Examples of Scalyr's PageAlert component
 */

function PageAlertExamplePage(): JSX.Element {
  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);

  const showInfoAlert = (): void => {
    setPageAlertConfig({ message: 'Short message', autoHide: true });
  };
  const showWarningAlert = (): void => {
    setPageAlertConfig({ message: 'This is a warning', variant: PageAlertVariant.WARNING, autoHide: false });
  };
  const showSuccessAlert = (): void => {
    setPageAlertConfig({ message: 'That totally worked', variant: PageAlertVariant.SUCCESS, autoHide: false });
  };
  const showErrorAlert = (): void => {
    setPageAlertConfig({ message: 'Nope', variant: PageAlertVariant.ERROR, autoHide: false });
  };
  const showProgressAlert = (): void => {
    setPageAlertConfig({
      message: 'Working',
      variant: PageAlertVariant.INFO,
      dismissible: false,
      inProgress: true,
      autoHide: false,
    });
  };
  const showWarningProgressAlert = (): void => {
    setPageAlertConfig({
      message: 'Working',
      variant: PageAlertVariant.WARNING,
      dismissible: false,
      inProgress: true,
      autoHide: false,
    });
  };
  const showDismissibleAlert = (): void => {
    setPageAlertConfig({ message: 'This message must be dismissed', variant: PageAlertVariant.INFO, autoHide: false });
  };
  const showAutoHideAlert = (): void => {
    setPageAlertConfig({
      message: 'This will go away on its own',
      variant: PageAlertVariant.INFO,
      dismissible: false,
      autoHide: true,
    });
  };
  const showAlertWithHeading = (): void => {
    setPageAlertConfig({
      heading: 'Heading',
      message: 'Message body',
      variant: PageAlertVariant.INFO,
      autoHide: false,
    });
  };

  return (
    <section id="pageAlert" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Page Alert</h1>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button onClick={showInfoAlert}>Show Info Alert</Button>
        <Button onClick={showWarningAlert}>Show Warning Alert</Button>
        <Button onClick={showSuccessAlert}>Show Success Alert</Button>
        <Button onClick={showErrorAlert}>Show Error Alert</Button>
      </div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button onClick={showProgressAlert}>Show Alert with Spinner</Button>
        <Button onClick={showWarningProgressAlert}>Show Warning Alert with Spinner</Button>
      </div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button onClick={showDismissibleAlert}>Show Dismissible Alert</Button>
        <Button onClick={showAutoHideAlert}>Show AutoHide Alert</Button>
      </div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button onClick={showAlertWithHeading}>Show Alert with Heading</Button>
      </div>
    </section>
  );
}
export default PageAlertExamplePage;
